/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@mui/material";
import WebpageEditContext from "components/webpage-selector/context";

const WebpageDialogBottomActions = () => {
    const { t } = useTranslation();
    const ctx = useContext(WebpageEditContext);
    const handleClose = ctx?.handleClose;
    const selectedWebpage = ctx?.selectedWebpage;
    const onSelectWebpage = ctx?.onSelectWebpage;
    const cancelDisabled = false;
    
    const handleSelect = () => {
        onSelectWebpage(selectedWebpage);
    };

    return (
        <div className="simplicity-image-selector-window-footer">
            <Button variant='outlined' color='secondary' onClick={handleClose} disabled={cancelDisabled}>
                {t("commons.cancel")}
            </Button>
            <Button variant='contained' color='primary' onClick={handleSelect}>
                {t("commons.select")}
            </Button>
        </div>
    );
};

export { WebpageDialogBottomActions };
